import React from "react";
import { FaTimes } from "react-icons/fa";
import "../styles/ResourceView.css";

export default function ResourceView({ data, onClose }) {
  if (!data) return null;

  return (
    <div className="resource-view-overlay">
      <div className="resource-view-modal">
        {/* Header */}
        <div className="resource-view-header">
          <h2>Detailed Update</h2>
          <button className="resource-view-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Content Box */}
        <div className="resource-view-box">
          <h3 className="resource-view-title">{data.item} Update</h3>
          <p><strong>Date:</strong> {data.date}</p>
          <p><strong>Category:</strong> {data.category}</p>
          <p><strong>Item Code:</strong> {data.code}</p>
          <p><strong>Quantity:</strong> {data.quantity}</p>
          <p><strong>Project:</strong> {data.project}</p>
          <p><strong>Remark/Note:</strong> {data.remark}</p>
        </div>
      </div>
    </div>
  );
}
